import { render, staticRenderFns } from "./SpreadsheetEditor.vue?vue&type=template&id=a308f2b2&scoped=true"
import script from "./SpreadsheetEditor.vue?vue&type=script&setup=true&lang=ts"
export * from "./SpreadsheetEditor.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SpreadsheetEditor.vue?vue&type=style&index=0&id=a308f2b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a308f2b2",
  null
  
)

export default component.exports